const css = `.P1xE7q__listItemIcon{width:24px;flex-shrink:0;justify-content:center;display:inline-flex}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"listItemIcon":"P1xE7q__listItemIcon"};
